module.exports = __webpack_public_path__ + "static/memory_img6M@2x-135c22665abf915de46d07bfb455d56d.png";